import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patient-prescriptions-table',
  templateUrl: './patient-prescriptions-table.component.html',
  styleUrls: ['./patient-prescriptions-table.component.css']
})
export class PatientPrescriptionsTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
